"use client";
import LightboxComponent, {
  CaptionsRef,
  SlideImage,
} from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import Captions from "yet-another-react-lightbox/plugins/captions";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";

import { useWindowSize } from "@/hooks/use-window-size";
import React, { useMemo } from "react";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

type Props = {
  images: (SlideImage & { title?: string; description?: string })[];
  onClose: () => void;
  index: number;
};

export default function Lightbox({ images, index, onClose }: Props) {
  const captionsRef = React.useRef<CaptionsRef>(null);
  const { width } = useWindowSize();

  const plugins = useMemo(() => {
    if (width < 768) {
      return [Captions, Thumbnails];
    }

    return [Fullscreen, Zoom, Slideshow, Thumbnails, Captions];
  }, [width]);

  return (
    <LightboxComponent
      slides={images}
      captions={{
        ref: captionsRef,
        descriptionTextAlign: "center",
        descriptionMaxLines: 10,
      }}
      on={{
        click: () => {
          (captionsRef.current?.visible
            ? captionsRef.current?.hide
            : captionsRef.current?.show)?.();
        },
      }}
      open={index >= 0}
      index={index}
      close={() => onClose?.()}
      className="z-[999999999]"
      plugins={plugins}
    />
  );
}
